import Cookies from 'cookies'
import { type GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import { CookieRegistry } from '@/constants/cookieRegistry'
import { useSignin } from '@/features/auth/hooks/useSignin'
import { getCookieSubDomain } from '@/utils/cookies/getCookieSubDomain'

// User lands on this page after being mapped here from /t-login.html
export default function CisLoginRedirectPage() {
  const { query } = useRouter()
  const callbackUrl = Array.isArray(query.redirectUrl) ? query.redirectUrl[0] : query.redirectUrl

  useSignin({ callbackUrl })

  return null
}

// ServerSideProps needed to populate "query" on first render
export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  /**
   * Address a defect that sometimes is observed wherein kj-at and kj-rt get cleared, but kj-st does not
   * This defect creates the state in legacy where the header appears to be logged out,
   * but NWA think you're logged in, so consumer/login just kicks you back to home.
   */
  const cookies = new Cookies(req, res, {
    secure: process.env.NODE_ENV !== 'development',
  })
  const at = cookies.get(CookieRegistry.ACCESS_TOKEN)
  const rt = cookies.get(CookieRegistry.REFRESH_TOKEN)
  const st = cookies.get(CookieRegistry.SESSION_JWT)
  if (st && (!at || !rt)) {
    const hostname = req.headers.host || ''
    const domain = getCookieSubDomain(hostname)
    cookies.set(CookieRegistry.ACCESS_TOKEN, undefined, {
      domain,
      secure: process.env.NODE_ENV !== 'development',
    })
    cookies.set(CookieRegistry.REFRESH_TOKEN, undefined, {
      domain,
      secure: process.env.NODE_ENV !== 'development',
    })
    cookies.set(CookieRegistry.SESSION_JWT, undefined, {
      domain,
    })
  }
  return { props: {} }
}
